// extracted by mini-css-extract-plugin
export default {"formula":"_2Hhl3 _2zlem Wr_al","formulaHeader":"_3CI1f _38618 _3Dqep _20SLo _2XN97 _1aL0S","formulaTitle":"kp0FY _1Wqf2","formulaDefinitionInner":"_1kWrk _2z9kb"};